export const displayStatus = (s) => (s === "Immediate Attention" ? "Beyond Design Life" : s);

export const CONSEQ = {
  major: { label: "Major — whole site", short: "Major", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  moderate: { label: "Moderate — local area", short: "Moderate", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  minimal: { label: "Minimal — <10 people", short: "Minimal", cls: "bg-slate-50 text-slate-500 border-slate-200" },
};

export const RATING = {
  5: { label: "Severe — whole site", short: "R5 Severe", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  4: { label: "Major — multiple areas", short: "R4 Major", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  3: { label: "Moderate — local area", short: "R3 Moderate", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  2: { label: "Minor — single system", short: "R2 Minor", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  1: { label: "Minimal — negligible", short: "R1 Minimal", cls: "bg-slate-50 text-slate-500 border-slate-200" },
};

export const ConsequenceBadge = ({ a, testid }) => {
  const r = a?.consequence_rating;
  const meta = r ? RATING[r] : CONSEQ[a?.consequence];
  if (!meta) return null;
  return (
    <span data-testid={testid}
          className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[10px] font-medium ${meta.cls}`}
          title={`${meta.label}${a.consequence_source === "client_profile" ? " · client-tuned" : a.consequence_source === "asset_override" ? " · manual override" : ""}`}>
      {meta.short}
      {a.consequence_source === "client_profile" && <span className="w-1.5 h-1.5 rounded-full bg-current opacity-60" />}
    </span>
  );
};
